<template>
  <div class="index-index-container">
    <atlasMoreProduct :checkStatus="true" :orderParams="JSON.parse(decodeURIComponent($route.query.orderParams))" @checkStatus="onCheckStatus"></atlasMoreProduct>
    <div class="index-atlas-button">
      <span class="send" @click="onOrderAtlasProduct()">快速下单</span>
    </div>
  </div>
</template>

<script>
import atlasMoreProduct from '@/components/atlas/atlasMoreProduct';
import { isWeChatApplet } from "@/utils/util";
import utils from "@/utils/common";
export default {
  data () {
    return {
      orderParams: {}
    }
  },
  components: {atlasMoreProduct},
  created () {
    this.$loading.hide();
    this.orderParams = {
      branchId: JSON.parse(decodeURIComponent(this.$route.query.orderParams)).branchId,
      discoverIds: [],
      shareId: JSON.parse(decodeURIComponent(this.$route.query.orderParams)).shareId
    }
  },
  methods: {
    onCheckStatus: function (event) {
      this.orderParams.discoverIds = event.idArray
    },
    onOrderAtlasProduct: function () {
      var params = {
        tm: 3020103,
        tp: {
          orderParams: this.orderParams
        }
      }
      if (this.orderParams.discoverIds.length==0) {
        Toast('请勾选需要提交的商品');
      } else {
        utils.nativeMethod(params);
      }
    }
  }
}
</script>

<style lang="less" scoped>
.index-atlas-button{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background-color: white;
  height: 98px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 30px;
}
.index-atlas-button .send{
  flex: 1;
  height:76px;
  background:rgba(248,213,65,1);
  border-radius:76px;
  text-align: center;
  line-height: 76px;
  font-size: 26px;
  margin-left: 30px;
}
</style>